<template>
<a href="https://mosaic.aixeta.cat/ca" target="_blank" class="relative max-w-screen-sm mx-auto" v-if="!hide">
    
    <button @click.prevent class="p-2 pl-6 pb-6 absolute top-0 right-0 text-xl text-white" @click="hide=true"><font-awesome-icon :icon="['fas', 'xmark']" /></button>
    <img :src="anunci" alt="Ajuda el Mosaic a prosperar amb una donació o subscripció i rep novetats i recompenses exclusives! mosaic.aixeta.cat" class="w-full h-full object-contain"/>
</a>
</template>

<script setup>
import {ref} from 'vue';
import anunci from '@/assets/anunci_aixeta.png';
const hide = ref(false);

</script>